import styled from 'styled-components';
import { rem } from 'polished';
var FormContainer = styled.div.withConfig({
  displayName: "FormContainer",
  componentId: "juor65-0"
})(["margin:0 auto;max-width:", ";position:relative;width:100%;"], rem(360));
export default FormContainer;